import { createSelector } from '@reduxjs/toolkit';

import { getCreditCalcFormState, getCarDiscounts } from '.';
import getCarTradeIn from './getCarTradeIn';

type TBookOpts = {
  discountTradeInCarPrice: number;
  discountTradeIn: number;
  discountSuzukiFinance: number;
  discountMedical: number;
  monthPayment?: number;
  rate?: string;
  creditProgramm?: string;
  brand?: string;
  model?: string;
  tradeInPrice?: number;
};
/**
 * Параметры виджета "Кредитный калькулятор" и "Trade-In"
 */
const getCarBookOpts = createSelector(
  getCreditCalcFormState,
  getCarDiscounts,
  getCarTradeIn,
  (
    formState,
    {
      tradeInPrice,
      resolvedTradeInDiscount,
      resolvedSuzukiFinanceDiscount,
      medicalDiscount,
    },
    tradeIn
  ) => {
    const bookOpts: TBookOpts = {
      // данные trade-in
      brand: tradeIn.brand,
      model: tradeIn.model,
      tradeInPrice: tradeInPrice.value,

      // данные выгод (discounts)
      discountTradeInCarPrice: tradeInPrice.selected ? tradeInPrice.value : 0,
      discountTradeIn: resolvedTradeInDiscount.selected
        ? resolvedTradeInDiscount.value
        : 0,
      discountMedical: medicalDiscount.selected ? medicalDiscount.value : 0,
      discountSuzukiFinance: resolvedSuzukiFinanceDiscount.selected
        ? resolvedSuzukiFinanceDiscount.value
        : 0,
    };

    // данные кредитного калькулятора
    if (formState) {
      const { rate, current, monthPayment, credits } = formState.credits;
      const currentCredit = credits.find(item => item.id === current);

      bookOpts.monthPayment = monthPayment
        ? Number.parseInt(monthPayment.replace(/\s/g, ''), 10)
        : undefined;
      bookOpts.creditProgramm = currentCredit?.title;
      bookOpts.rate = rate;
    }

    return bookOpts;
  }
);

export default getCarBookOpts;
